import { formatMoney } from '../../utils/currency';

let theme = window.theme || {};
let Shopify = window.Shopify || {};

/**
 * Handle several analytics and pixel events when an new item is added to the cart.
 * It isn't called under edit cart item scenarios
 * @param {Shopify Cart Object} cart - Shopify Cart Liquid Object https://shopify.dev/docs/api/liquid/objects/cart
 * @param {HTML form} form - HTML form node
 * @returns
 */
export default function (cart, form) {
  if (!form) {
    return;
  }

  const element = form;
  const dataAttribute = element && element.getAttribute('data-form-template');

  var cartProductIds = [];
  if (dataAttribute) {
    if (dataAttribute.includes('ajax')) {
      // means its coming from quickview

      var cartItems = cart.items;

      var cartData = [];
      for (var i = 0; i < cartItems.length; i++) {
        var cartItem = cartItems[i];
        var price = formatMoney(cartItem.price, theme.moneyFormat);
        price = price.replace(/[$A-Za-z,\s]+/g, '');
        if (!/^\d/.test(price)) {
          price = price.slice(1);
        }
        var cartItemData = {
          productId: cartItem.product_id.toString(),
          quantity: cartItem.quantity.toString(),
          unitPrice: price,
          currency: Shopify.currency.active.toString(),
          sku: cartItem.variant_id.toString(),
        };
        cartData.push(cartItemData);
        cartProductIds.push(cartItem.product_id);
      }
    } else {
      if (!window.location.href.includes('cart')) {
        cartItems = window.cart.items;

        cartData = [];
        for (i = 0; i < cartItems.length; i++) {
          cartItem = cartItems[i];
          price = formatMoney(cartItem.price, theme.moneyFormat);
          price = price.replace(/[$A-Za-z,\s]+/g, '');
          if (!/^\d/.test(price)) {
            price = price.slice(1);
          }
          cartItemData = {
            productId: cartItem.product_id.toString(),
            quantity: cartItem.quantity.toString(),
            unitPrice: price,
            currency: Shopify.currency.active.toString(),
            sku: cartItem.variant_id.toString(),
          };
          cartData.push(cartItemData);
          cartProductIds.push(cartItem.product_id);
        }
      }
    }
  }

  // we will set window.cart here because we are bringing the entire cart data from Shopify server
  window.cart = cart;
}
